export const AppIsInTestEnvironment = () => {
    return (
        process.env.REACT_APP_NODE_ENV === 'dev' ||
        process.env.REACT_APP_NODE_ENV === 'test'
    )
}